import { NgFor, NgIf } from '@angular/common';
import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { Link, StickyNavbarModule } from '@com-delta-idp/mnx-ui-kit';
import { Size, WindowUtilsService } from '@com-delta-idp/mnx-utils';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SectionComponent } from './components/section/section.component';
import { Current, Menu, SCREEN_WIDTH, Section } from './models/menu.interfaces';

@Component({
  selector: 'idp-menu',
  standalone: true,
  imports: [StickyNavbarModule, NavbarComponent, SectionComponent, NgIf, NgFor],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnChanges {
  @Input() content: Menu = {} as Menu;

  height = '';
  sections: Section[] = [];
  current: Current = {} as Current;

  constructor(private utils: WindowUtilsService, private router: Router) {}

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.current.toggle = window.innerWidth >= SCREEN_WIDTH.MOBILE;
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.sections = this.cloneSections(changes);
    this.setCurrentValues();
  }

  setCurrentValues() {
    if (window.location.href.includes('my-profile')) {
      this.current = this.updateCurrentValues(
        '',
        'Account Menu',
        window.innerWidth >= SCREEN_WIDTH.MOBILE
      );
    } else {
      this.content.sections[0].items.forEach((item) => {
        if (item.selected) {
          const { url, label } = { ...item.link };
          this.current = this.updateCurrentValues(
            url,
            label,
            window.innerWidth >= SCREEN_WIDTH.MOBILE
          );
        }
      });
    }
  }

  validateDevice() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      const resolution: Size = this.utils.getScreenResolution();
      this.height = this.screenHeight(resolution.width, resolution.height, 64);
    } else {
      this.height = this.screenHeight(
        window.innerWidth,
        window.innerHeight,
        133
      );
    }
  }

  screenHeight(width: number, height: number, navBarOffSetHeight: number) {
    const headerOffSetHeight = 47;
    return width <= 1200
      ? height - navBarOffSetHeight - headerOffSetHeight + 'px'
      : '100%';
  }

  init() {
    this.onResize();
    this.setCurrentValues();
    this.validateDevice();
  }

  cloneSections(changes: SimpleChanges): Section[] {
    if (
      changes['content'].currentValue &&
      changes['content'].currentValue.sections.length
    ) {
      return JSON.parse(
        JSON.stringify(changes['content'].currentValue.sections)
      );
    }
    return [];
  }

  updateCurrentValues(url: string, label: string, toggle: boolean): Current {
    return { url, label, toggle };
  }

  updateLabelAndUrl(link: Link) {
    const current = this._getMatchingItemId(link.label);

    this.current = this.updateCurrentValues(
      link.url,
      link.label,
      window.innerWidth >= SCREEN_WIDTH.MOBILE
    );

    this._routeExists(current)
      ? this.router.navigate([current])
      : window.open(link.url, '_self');
  }

  private _getMatchingItemId(label: string): string {
    let foundId = '';

    this.sections.forEach((section) => {
      section.items.forEach((item) => {
        item.selected = false;

        if (item.link.label.toLowerCase() === label.toLowerCase()) {
          item.selected = true;
          foundId = item.id;
        }
      });
    });

    return foundId;
  }

  private _routeExists(route: string): boolean {
    return this.router.config.some((r) => r.path === route);
  }
}
